import { colorsPalettes, mixins } from "@similarweb/styles";
import { capitalizeFirstLetter } from "app/pages/sales-intelligence/common-components/styles";
import { FlexColumn, FlexRowFlexStart } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledMainSectionWrapper = styled(FlexColumn)`
    row-gap: 12px;
`;

export const StyledTagsSectionWrapper = styled(FlexColumn)`
    margin-top: 24px;
`;

export const StyledSectionTitle = styled.div`
    ${mixins.setFontVariant("sectionTitle", colorsPalettes.bluegrey[500])};
    ${capitalizeFirstLetter};

    font-weight: 500;
`;

export const StyledTagsWrapper = styled(FlexRowFlexStart)`
    gap: 4px;
    margin-top: 8px;
    flex-wrap: wrap;
`;
